import React, { useEffect, useMemo } from "react";
import { gettext, cropr } from "../../adapter";
import NProgress from "../../libraries/progress";
import NoRights from "./NoRights";
import LoadError from "../LoadError";
import Loader from "../Loader";
import { useDispatch, useSelector } from "react-redux";
import WeatherDataStations from "./WeatherDataStations";
import WeatherDataCharts from "./WeatherDataCharts";
import { parseStations } from "../../utils/weatherStationUtils";
import { fetchStations } from "../../actions/weatherStationsActions";

const WeatherData = ({ apiUrl }) => {
  const dispatch = useDispatch();
  const stationsState = useSelector((state) => {
    return state.weatherStations;
  });

  const fetchPeriod = useSelector((state) => {
    return state.weatherStation.fetchPeriod;
  });

  const stations = useMemo(() => {
    const stations = parseStations(stationsState.items);

    // Get the selected station
    var selectedStation;
    if (!stationsState.isFetching && stations.length > 0) {
      selectedStation = stations.find((item) => {
        return item.id === stationsState.selectedStation;
      });
    }
    return { ...stationsState, items: stations, selectedStation };
  }, [stationsState]);

  useEffect(() => {
    NProgress.start();
    dispatch(fetchStations(apiUrl));
  }, [dispatch, apiUrl]);

  if (stations.isFetching === true) {
    return <Loader message={gettext("Loading weather data...")} />;
  }

  if (!cropr.features.dacom_online_weather || (stations.items && stations.items.length === 0)) {
    NProgress.done();
    return <NoRights message={gettext("Demo weather data")} image_class="weather-data" />;
  }

  if (!stations.items && stations.loadError) {
    NProgress.done();
    return <LoadError />;
  }

  NProgress.done();

  return (
    <div>
      <WeatherDataStations
        apiUrl={apiUrl}
        stations={stations.items}
        selectedStation={stations.selectedStation}
        fetchPeriod={fetchPeriod}
      />
      <WeatherDataCharts apiUrl={apiUrl} />
    </div>
  );
};

export default WeatherData;
